class Accordion {
    constructor() {
        this.accordion = document.getElementsByClassName("accordion");
        this.panels = document.getElementsByClassName("panel");
        this.addEvents();
    }

    addEvents() {
        for (let i = 0; i < this.accordion.length; i++) {
            this.accordion[i].addEventListener("click", () => {
                for (let j = 0; j < this.panels.length; j++) {
                    if (this.panels[j] !== this.panels[i] && this.panels[j].classList.contains('active')) {
                        this.panels[j].classList.remove('active');
                        this.panels[j].style.maxHeight = null;
                    }
                }

                this.togglePanel(this.panels[i]);
            });
        }
    }

    togglePanel(panel) {
        panel.classList.toggle("active");
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    }
}

export default Accordion;
